import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377c9fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table-page-search-submitButtons",
  style: { float: 'right', overflow: 'hidden' } || {}
}
const _hoisted_2 = { class: "button-collection-r" }
const _hoisted_3 = { key: 0 }

import { ref, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { fmoney } from "@/utils/tools";
import { getDic } from "@/api/pos";
import { claimInquiryList, claimExport } from "@/api/claim";
import {
  DownOutlined,
  UpOutlined,
  DownloadOutlined,
  BarsOutlined,
  ExportOutlined,
} from "@ant-design/icons-vue";
import ClaimExportRecordModal from "./modules/ClaimExportRecordModal.vue";
import { FormInstance, message } from "ant-design-vue";
import { debounce } from "@/utils/tools";
interface FormState {
  state: string | null;
  liabilityType: string | null;
  collectionDateFrom: string | null;
  collectionDateTo: string | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimInquiry',
  setup(__props) {

const dataSource = ref<Array<any>>([]);
const loading = ref<boolean>(false);
const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const pageSizeConfig = ref(10);
const totalData = ref(0);
const claimExportRecordModal = ref(null);
const claimStateDicList = ref<Array<any>>([]);
const liabilityTypeDicList = ref<Array<any>>([]);
const collectionDateFrom = ref<string>("");
const collectionDateTo = ref<string>("");
const openMore = ref<boolean>(false);
const formRef = ref<FormInstance>();
const formState = reactive<FormState>({
  state: null,
  liabilityType: null,
  collectionDateFrom: null,
  collectionDateTo: null,
});
const columns = ref<Array<any>>([
  {
    title: "理赔ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "被保险人 ID ",
    dataIndex: "userInsurerId",
    key: "userInsurerId",
  },
  {
    title: "人员类型",
    dataIndex: "relationZh",
    key: "relationZh",
  },
  {
    title: "案件申请时间",
    dataIndex: "collectionDate",
    key: "collectionDate",
  },
  {
    title: "责任类型",
    dataIndex: "liabilityTypeZh",
    key: "liabilityTypeZh",
  },
  {
    title: "案件状态",
    dataIndex: "stateZh",
    key: "stateZh",
  },
  {
    title: "赔付金额",
    dataIndex: "payoutAmount",
    key: "payoutAmount",
  },
  {
    title: "结案日期",
    dataIndex: "caseCloseDate",
    key: "caseCloseDate",
  },
  {
    title: "拒赔/撤案原因",
    dataIndex: "paidDelayDesc",
    key: "paidDelayDesc",
    width: "500px",
  },
]);

onMounted(() => {
  getTableData();
  getDic({}).then((res) => {
    claimStateDicList.value = res.data.claimStateDicList;
    liabilityTypeDicList.value = res.data.liabilityTypeDicList;
  }).catch;
});

const getTableData = async (data: any = {}) => {
  loading.value = true;
  let res: any = await claimInquiryList(data);
  if (res.code == 200) {
    dataSource.value = res.data.dataList;
    totalData.value = res.data.total;
    currentPage.value = res.data.pageNum;
  }

  loading.value = false;
};

const showExportModal = () => {
  if (claimExportRecordModal.value) claimExportRecordModal.value.showModal();
};

const handleExport = debounce(async () => {
  let values = {
    state: formState.state,
    liabilityType: formState.liabilityType,
    collectionDateFrom: collectionDateFrom.value,
    collectionDateTo: collectionDateTo.value,
  };
  let resExport: any = await claimExport(values);
  if (resExport.code == 200) {
    message.success("导出成功，请前往导出记录查看下载");
  } else {
    message.error("导出失败");
  }
}, 500);

const handleFinishFailed = (errors: any) => {
  console.log(errors);
};

const handleSearch = (values: FormState) => {
  values.collectionDateFrom = collectionDateFrom.value;
  values.collectionDateTo = collectionDateTo.value;
  getTableData(values);
};

const onChangeRangePicker = (date: any, dateString: any) => {
  collectionDateFrom.value = dateString[0];
  collectionDateTo.value = dateString[1];
};
const onChangePage = (pageNum: number, pageSize: number) => {
  let data = {
    pageNum: pageNum,
    pageSize: pageSize,
    state: formState.state ? formState.state : null,
    liabilityType: formState.liabilityType ? formState.liabilityType : null,
    collectionDateFrom: collectionDateFrom.value
      ? collectionDateFrom.value
      : null,
    collectionDateTo: collectionDateTo.value ? collectionDateTo.value : null,
  };
  currentPage.value = pageNum;
  pageSizeConfig.value = pageSize;
  getTableData(data);
};
const Reset = () => {
  if (formRef.value) formRef.value.resetFields();
  collectionDateFrom.value = "";
  collectionDateTo.value = "";
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { style: {"max-width":"1440px","margin":"0 auto","margin-top":"32px"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            model: formState,
            onFinish: handleSearch,
            onFinishFailed: handleFinishFailed,
            style: {"text-align":"left"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 6,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "案件状态：",
                        name: "state"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: formState.state,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.state) = $event)),
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(claimStateDicList.value, (foo) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: foo.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(foo.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 6,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "申请时间段：",
                        name: "collectionDateFrom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            value: formState.collectionDateFrom,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.collectionDateFrom) = $event)),
                            placeholder: ['开始日期', '结束日期'],
                            onChange: onChangeRangePicker
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (openMore.value)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        xxl: 6,
                        xl: 6,
                        lg: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "责任类型：",
                            name: "liabilityType"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: formState.liabilityType,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.liabilityType) = $event)),
                                placeholder: "请选择"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liabilityTypeDicList.value, (foo) => {
                                    return (_openBlock(), _createBlock(_component_a_select_option, {
                                      key: foo.code
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(foo.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 6,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, [
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"20px","width":"90px"},
                          type: "primary",
                          "html-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"16px","width":"90px"},
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (Reset()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("a", {
                          onClick: _cache[4] || (_cache[4] = 
                  () => {
                    openMore.value = !openMore.value;
                  }
                ),
                          style: {"margin-left":"8px","color":"#42b983"}
                        }, [
                          _createTextVNode(_toDisplayString(openMore.value ? "收起" : "展开") + " ", 1),
                          (!openMore.value)
                            ? (_openBlock(), _createBlock(_unref(DownOutlined), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(UpOutlined), { key: 1 }))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _unref(handleExport)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ExportOutlined)),
              _createTextVNode("导出理赔记录 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "button-c",
            type: "default",
            onClick: showExportModal
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BarsOutlined)),
              _createTextVNode("导出记录")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_table, {
          style: {"margin-top":"16px"},
          dataSource: dataSource.value,
          columns: columns.value,
          pagination: {
        current: currentPage.value,
        onChange: onChangePage,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total: totalData.value,
        pageSize: pageSizeConfig.value,
        showTotal: (totalData) => `共 ${totalData} 条数据`,
      },
          loading: loading.value
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'payoutAmount')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(fmoney)(record.payoutAmount)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "loading"])
      ]),
      _: 1
    }),
    _createVNode(ClaimExportRecordModal, {
      ref_key: "claimExportRecordModal",
      ref: claimExportRecordModal
    }, null, 512)
  ], 64))
}
}

})